import logoutConstants from '../constants/LogoutConstants';
import { logoutUser } from '../shared/requests/UserRequests';

function userLogoutRequest(token) {
  // action creators
  function request() {
    return {
      type: logoutConstants.LOGOUT_REQUEST,
    };
  }
  function success(status) {
    return {
      type: logoutConstants.LOGOUT_SUCCESS,
      status,
    };
  }
  function failure(error) {
    return {
      type: logoutConstants.LOGOUT_FAILURE,
      error,
    };
  }

  return function action(dispatch) {
    // begin request
    dispatch(request());
    logoutUser(token)
      .then((response) => {
        // logout success
        dispatch(success(response));
      }).catch((error) => {
        // login failure
        dispatch(failure(error.response));
      });
  };
}

function userLogoutRequestSynch(token) {
  // action creators
  function request() {
    return {
      type: logoutConstants.LOGOUT_REQUEST,
    };
  }
  function success(status) {
    return {
      type: logoutConstants.LOGOUT_SUCCESS,
      status,
    };
  }
  function failure(error) {
    return {
      type: logoutConstants.LOGOUT_FAILURE,
      error,
    };
  }

  return function action(dispatch) {
    return new Promise((resolve, reject) => {
      // begin request
      dispatch(request());
      logoutUser(token)
        .then((response) => {
          // logout success
          dispatch(success(response), resolve());
        }).catch((error) => {
          dispatch(failure(error.response), reject());
        });
    });
  };
}

export { userLogoutRequest, userLogoutRequestSynch };
